import { createStore, applyMiddleware, compose } from "redux";

// middlewares
import thunkMiddleware from "redux-thunk";

// Import custom components
import rootReducer from "../reducers";

// This store used to persist itself to localStorage: a `subscribe()` that ran
// `JSON.stringify` over the entire 27-slice state on *every* dispatch, plus a
// synchronous `setItem`. With this app's data (every user, lot and due invoice
// lives in the tree) that is megabytes serialised several times a second
// during boot — and past the ~5MB localStorage quota the write threw anyway,
// so the cost bought nothing.
//
// The matching `loadFromLocalStorage()` was just as pointless: it ran a
// multi-MB `JSON.parse` synchronously at module scope, before React mounted,
// and the result was never passed to `createStore` — so the app has never once
// rehydrated from it. Nothing else in the app reads the key either.
//
// Both are gone. If rehydration is ever actually wanted, add it deliberately:
// a whitelist of small slices only (never `users`/`lots`/`ordersAlg`), a
// throttled write, and the parsed state passed in as `preloadedState` here.
const LEGACY_STATE_KEY = "state";

try {
  // Existing browsers are still holding the old multi-MB dump. Nothing reads
  // it, so drop it once and stop it counting against the storage quota.
  if (localStorage.getItem(LEGACY_STATE_KEY) !== null) {
    localStorage.removeItem(LEGACY_STATE_KEY);
  }
} catch (e) {
  console.log(e);
}

/**
 * Create a Redux store that holds the app state.
 */
const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunkMiddleware),

    //For working redux dev tools in chrome (https://github.com/zalmoxisus/redux-devtools-extension)
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : function (f) {
          return f;
        },
  ),
);

export default store;
